import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import StorefrontIcon from "@mui/icons-material/Storefront";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { handleLogOut, handleModalAction } from "../../redux/actoin";
const SideBar = () => {
  const viewALl = true;
  const path = [
    {
      name: "داشبورد",
      path: "/",
      icon: <DashboardIcon />,
    },
    {
      name: "فروش",
      path: "/sell",
      icon: <StorefrontIcon />,
    },
    {
      name: "خرید",
      path: "/buy",
      icon: <ShoppingCartIcon />,
    },
    /*   {
      name: "هزینه",
      path: "/price",
      icon: <AttachMoneyIcon />,
    }, */
  ];
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Box
      component={"aside"}
      sx={{
        width: viewALl ? { md: "16.75rem", xs: "80%" } : "4rem",

        position: "fixed",
        left: 0,
        top: 0,
        height: "100%",
        zIndex: 100,
        borderLeft: "1px solid  #EEEEEE",
        transition: "transform 450ms ease, width 450ms ease",
        overflowY: "auto",
        overflowX: "hidden",
        transform: "translateX(0)",
        pb: 2,
      }}
      className=" overflow-hidden mainBg"
    >
      <Box
        className="items-center gap-4 h-20 border-b"
        sx={{ display: "flex", px: 3 }}
      >
        <img src="/assets/images/logo.png" alt="" className=" w-[50px]" />
        <span className="font-bold text-white text-lg">
          {process.env.REACT_APP_TITLE}
        </span>
      </Box>
      <Box
        component={"nav"}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          mt: 4,
          justifyContent: "space-between",
          height: "calc(100% - 7rem)",
        }}
      >
        <List
          sx={{
            color: "#f8f8f8",
            ".MuiListItemIcon-root": {
              color: "#f8f8f8",
              minWidth: "2rem",
            },
            px: 2,
          }}
        >
          {path?.map((item, index) => (
            <ListItem
              className={
                location.pathname.split("/")[1] === item?.path.slice(1)
                  ? "activeNav"
                  : ""
              }
              key={index}
              disablePadding
              onClick={() => {
                navigate(item.path);
                dispatch(handleModalAction({ login: false }));
              }}
            >
              <ListItemButton>
                <ListItemIcon>{item?.icon}</ListItemIcon>
                <ListItemText primary={item?.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <List
          sx={{
            color: "#f8f8f8",
            ".MuiListItemIcon-root": {
              color: "#f8f8f8",
              minWidth: "2rem",
            },
            px: 2,
            borderTop: "1px solid #cccccc",
          }}
        >
          <ListItem
            className={location.pathname === "/setting" ? "activeNav" : ""}
            disablePadding
            onClick={() => {
              navigate("/setting");
              dispatch(handleModalAction({ login: false }));
            }}
          >
            <ListItemButton>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="تنظیمات سایت" />
            </ListItemButton>
          </ListItem>
          <ListItem
            disablePadding
            onClick={() => {
              dispatch(handleModalAction({ login: false }));
              dispatch(handleLogOut());
            }}
          >
            <ListItemButton>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary=" خروج" />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};

export default SideBar;
